
/**
 * 名堂
 */
export namespace MingTangKind {

    export enum GeneralValue {
        
    }
    
    /** 牌型 */
    export enum CardType {
        /** 大四喜 */
        DA_SI_XI = 1, 
        /** 六六顺 */
        LIU_LIU_SHUN, 
        /** 小青龙 */
        XIAO_QING_LONG, 
        /** 天下无双 */
        TIAN_XIA_WU_SHUANG, 
        /** 九连宝灯 */
        JIU_LIAN_BAO_DENG, 
    }

    /** 牌型信息 */
    class CardTypeInfo {
        /** 名称 */
        name: string = '';
        /** 颜色 */
        color: cc.Color = null;
    }

    /** 牌型信息 */
    export const CardTypeInfoArr = {
        /** 大四喜 */
        [CardType.DA_SI_XI]: {
            name: '大四喜'
            , color: cc.color(0xe5, 0x6e, 0x5b)
        }, 
        /** 六六顺 */
        [CardType.LIU_LIU_SHUN]: {
            name: '六六顺'
            , color: cc.color(0xa5, 0xde, 0x6d)
        },
        /** 小青龙 */
        [CardType.XIAO_QING_LONG]: {
            name: '小青龙'
            , color: cc.color(0x79, 0xff, 0xce)
        },
        /** 天下无双 */
        [CardType.TIAN_XIA_WU_SHUANG]: {
            name: '天下无双'
            , color: cc.color(0xff, 0xa2, 0x29)
        },
        /** 九莲宝灯 */
        [CardType.JIU_LIAN_BAO_DENG]: {
            name: '九莲宝灯'
            , color: cc.color(0xfd, 0x79, 0xff)
        },
    }

    /** 牌型概率信息 */
    class CardTypeProbInfo {
        /** 概率 */
        prob: number = 0;
        /** 包含的牌型 */
        cardType: number[] = [];
    }

    /** 牌型概率 */
    export const CardTypeProb: CardTypeProbInfo[] = [
        {
            prob: 0.23
            , cardType: [
                CardType.DA_SI_XI
            ]
        },
        {
            prob: 0.25
            , cardType: [
                CardType.LIU_LIU_SHUN
            ]
        },
        {
            prob: 0.25
            , cardType: [
                CardType.XIAO_QING_LONG
            ]
        },
        {
            prob: 0.2
            , cardType: [
                CardType.TIAN_XIA_WU_SHUANG
            ]
        },
        {
            prob: 0.07
            , cardType: [
                CardType.JIU_LIAN_BAO_DENG
            ]
        },
    ];

    /** 中奖概率信息 */
    class WinProbInfo {
        /** 概率 */
        prob: number = 0;
        /** 金额 */
        sum: number = 0;
    }

    /** 中奖概率 */
    export const WinProb: WinProbInfo[] = [
        {
            prob: 0.21
            , sum: 0
        },
        {
            prob: 0.1
            , sum: 500
        },
        {
            prob: 0.15
            , sum: 6666
        },
        {
            prob: 0.15
            , sum: 8888
        },
        {
            prob: 0.1
            , sum: 88000
        },
        {
            prob: 0.07
            , sum: 660000
        },
        {
            prob: 0.05
            , sum: 5000000
        },
    ];

    /** 牌型数据 */
    export class CardTypeData {
        /** 牌 */
        card: number[] = [];
        /** 能胡的牌 */
        winCard: number[] = [];
    }

}

